import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  height: 50px;
  align-items: center;
  justify-content: space-between;
  margin-right: 30px;
  margin-left: 30px;
  padding: 20px 0;
  padding-bottom: 50px;
`;

export default Container;
